import React, { useState } from 'react';

import { Button } from 'react-bootstrap';
import { BlogHindiVerticallyCenteredModal } from '../../Modelhelper/Updatemodelhelper';
import { TbEdit } from 'react-icons/tb';
function Brandblogmodelhindi({ previousData, value }) {
    const [modalShow, setModalShow] = useState(false)
    return (
        <>
            <TbEdit className='h3' onClick={() => setModalShow(true)} variant="primary"></TbEdit>
            <BlogHindiVerticallyCenteredModal
                previousData={previousData}
                value={value}
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
}
export default Brandblogmodelhindi;